
import { RotateCcw } from 'lucide-react';
import { Badge, Button, cn, FormGroup, Label, SubSidebar } from 'twyne-new.ui'

import { useAppLayoutContext } from './context';
import { useCollapseOnMobile } from './hooks';

export default function AppSidebarFilters({ children, className = '' }) {
  const { filterCollapsed, setFilterCollapsed } = useAppLayoutContext()
  useCollapseOnMobile({ setCollapsed: setFilterCollapsed })

  return <SubSidebar
    collapsed={filterCollapsed}
    onClickCollapse={() => setFilterCollapsed(filterCollapsed => !filterCollapsed)}
    className={cn(className)}
  >
    <div className='grid grid-cols-2 items-center'>
      <h1 className='text-lg flex-row twy-text-base-accent'>
        Filters
      </h1>
      {!filterCollapsed && children}
    </div>
  </SubSidebar>
}

export function ResetFiltersButton({ onReset, disabled = false, count = 0, className = '' }) {
  return <FormGroup className={cn('shrink-0', className)}>
    <Label className='invisible' aria-hidden>Reset</Label>
    <Button size='sm' variant='outline' color='warning' onClick={onReset} disabled={disabled}>
      <RotateCcw size={14} />
      Reset
      {count > 0 && <Badge size='sm' color='warning'>{count}</Badge>}
    </Button>
  </FormGroup>
}
